/**
 * The Trajan action: take the top tile of one stack and place it on the slot
 * the Arch marks; the Arch moves clockwise to the next free slot, or to the
 * centre when the circle is full.
 */
import { afterAction, fail, playerOf, succeed, updatePlayer, } from '../internal.js';
import { TRAY_COUNT } from '../types.js';
/** Where the Arch goes after `from` is filled: the next free slot clockwise, or the centre. */
export function nextArch(slots, from) {
    for (let step = 1; step <= TRAY_COUNT; step++) {
        const i = ((from + step) % TRAY_COUNT);
        if (slots[i] === null)
            return i;
    }
    return 'center';
}
export function canTakeTrajanTile(player) {
    return player.arch !== 'center';
}
export function takeTrajanTile(state, actor, stack) {
    const player = playerOf(state, actor);
    if (player.arch === 'center')
        return fail('ILLEGAL', 'all six Trajan slots are full');
    const pile = state.board.trajanStacks[stack];
    if (!Number.isInteger(stack) || !pile)
        return fail('ILLEGAL', `no Trajan stack ${stack}`);
    const tile = pile[0];
    if (!tile)
        return fail('ILLEGAL', `Trajan stack ${stack} is empty`);
    const slot = player.arch;
    const trajanSlots = [...player.trajanSlots];
    trajanSlots[slot] = tile;
    const arch = nextArch(trajanSlots, slot);
    const trajanStacks = state.board.trajanStacks.map((s, i) => (i === stack ? s.slice(1) : s));
    let next = updatePlayer(state, actor, (p) => ({ ...p, trajanSlots, arch }));
    next = { ...next, board: { ...next.board, trajanStacks } };
    const events = [
        { type: 'TrajanTileTaken', player: actor, stack, tileId: tile.id, slot },
        { type: 'ArchMoved', player: actor, to: arch },
    ];
    return succeed(afterAction(next), events);
}
//# sourceMappingURL=trajan.js.map